const NOT_GROUPED = 'not-grouped'
const NO_URL = 'no-url'
const HOME = 'home'

/** @type {{ prefix: string, name: string }[]} */
const ROUTE_GROUPS = [
    { prefix: '/_toad', name: 'toad-assets' },
    // { prefix: '/_next', name: 'next-assets' },
    { prefix: '/sw.js', name: 'sw-js' },
    { prefix: '/workbox-', name: 'workbox-assets' },
    { prefix: '/worker-', name: 'worker-assets' },
    { prefix: '/manifest.', name: 'manifest-assets' },
    { prefix: '/api/', name: 'api' },
    { prefix: '/about-us', name: 'about-us' },
    { prefix: '/privacy', name: 'privacy' },
    { prefix: '/faq', name: 'faq' },
    { prefix: '/contact-us', name: 'contact-us' },
    { prefix: '/preview', name: 'preview' },
    { prefix: '/login-failed', name: 'login-failed' },
    { prefix: '/profile', name: 'profile' },
    { prefix: '/categories', name: 'categories' },
    { prefix: '/tags', name: 'tags' },
    { prefix: '/brands', name: 'brands' },
    { prefix: '/brand-categories', name: 'brand-categories' },
    { prefix: '/products', name: 'products' },
    { prefix: '/checkout', name: 'checkout' },
    { prefix: '/cart', name: 'cart' },
    { prefix: '/orders', name: 'orders' },
    { prefix: '/payments', name: 'payments' },
    { prefix: '/search', name: 'search' },
    { prefix: '/landing', name: 'landing' },
    { prefix: '/popup', name: 'popup' },
    { prefix: '/support', name: 'support' },
    { prefix: '/videos', name: 'videos' },
    { prefix: '/facets', name: 'facets' },
    { prefix: '/closeup', name: 'closeup' },
    { prefix: '/iranian-women', name: 'iranian-women' },
]

/**
 * Collapses a URL path to a bounded label, so neither Prometheus series nor RUM
 * rows explode into one entry per product slug.
 *
 * @param {string} path
 * @returns {string}
 */
function getRouteGroup(path) {
    const normalizedPath =
        path
            .replace(/\?.*$/, '') // remove query string
            .replace(/\/{2,}/g, '/') // replace all multiple slashes with single
            .replace(/\/$/, '') || // remove trailing slash
        '/' // if it's empty, it was `/`

    if (normalizedPath.trim() === '') return NO_URL
    if (normalizedPath === '/') return HOME

    const found = ROUTE_GROUPS.find((m) => normalizedPath.startsWith(m.prefix))

    return found ? found.name : NOT_GROUPED
}

module.exports = { ROUTE_GROUPS, NOT_GROUPED, NO_URL, HOME, getRouteGroup }
